import { ReactComponent as marketplaces } from "assets/icons/cardIcons/Marketplaces.svg";
import { ReactComponent as settings } from "assets/icons/cardIcons/Settings.svg";
import { ReactComponent as addProducts } from "assets/icons/cardIcons/AddProducts.svg";
import { ReactComponent as priceList } from "assets/icons/cardIcons/PriceList.svg";
import { ReactComponent as warehouse } from "assets/icons/cardIcons/Warehouse.svg";
import { ReactComponent as productPacking } from "assets/icons/cardIcons/ProductPacking.svg";
import { ReactComponent as orders } from "assets/icons/cardIcons/Orders.svg";
import { ReactComponent as analytics } from "assets/icons/cardIcons/Analytics.svg";
import { ReactComponent as paymentAccount } from "assets/icons/cardIcons/PaymentAccount.svg";
import { ReactComponent as resolvingFunds } from "assets/icons/cardIcons/WorkingCapitalRequest.svg";
import { ReactComponent as BookkeepingIcon } from "assets/icons/cardIcons/BookkeepingIcon.svg";
import { ReactComponent as Education } from "assets/icons/cardIcons/Education.svg";
import { ReactComponent as Adversting } from "assets/icons/cardIcons/Adversting.svg";
import { ReactComponent as Analysis } from "assets/icons/cardIcons/Analysis.svg";
import { ReactComponent as SEO } from "assets/icons/cardIcons/SEO.svg";
import { ReactComponent as Sales } from "assets/icons/cardIcons/Sales.svg";
import { ReactComponent as RegistrationSeller } from "assets/icons/cardIcons/RegistrationSeller.svg";
import { ReactComponent as AddCards } from "assets/icons/cardIcons/addCards.svg";
import { ReactComponent as Barcode } from "assets/icons/cardIcons/Barcode.svg";

import FormPaymentAccount from "components/Forms/FormPaymentAccount";
import FormResolvingFunds from "components/Forms/FormResolvingFunds";
import FormBookkepeeping from "components/Forms/FormBookkeeping";
import FormGeneral from "components/Forms/FormGeneral";
import FormInviteUser from "../../components/Forms/FormInviteUser";

const separators = {
    arrow: "->",
    plus: "+"
}

export enum CardType {
    link = "link",
    callback = "callback",
    youtubeVideo = "youtubeVideo",
    statistic = "statistic",
    integration = "integration",
    tools = "tools"
}

export const educationCards = [
    {
        type: CardType.integration,
        link: "https://t.me/academyecom_bot",
        icon: Education,
        title: "Академия Е.КОМ",
        description: "Телеграмм-бот селлерам: учебные курсы, ИИ-помощник, чат продавцов, общение с экспертами Academy-E.COM",
        buttonText: "Connect",
        separator: separators.arrow,
    },
    {
        type: CardType.integration,
        icon: Education,
        title: "Консультации с экспертом",
        description: "Консультации по работе с маркетплейсами с экспертом",
        buttonText: "Подробнее",
        separator: separators.arrow,
        link: "https://lkmarket.ru/services?utm_referrer=1017887#rec870886211"
    },
    {
        type: CardType.integration,
        link: "https://lkmarket.ru/courses/wildberries?utm_referrer=1017887",
        icon: Education,
        title: "Курс по Wildberries",
        description: "Авторский курс, ежедневные мини-уроки по торговой площадке Wildberries",
        buttonText: "more",
        separator: separators.arrow,
    },
    {
        type: CardType.integration,
        link: "https://lkmarket.ru/courses/ozon?utm_referrer=1017887",
        icon: Education,
        title: "Курс по Ozon",
        description: "Авторский курс, ежедневные мини-уроки по торговой площадке Ozon",
        buttonText: "more",
        separator: separators.arrow,
    },
    {
        type: CardType.callback,
        icon: Education,
        title: "Экспресс курс",
        description: "2-х недельный мини-курс, видео уроки по конкретной торговой площадке",
        buttonText: "Send callback",
        separator: separators.arrow,
        Form: FormGeneral,
    },
    {
        type: CardType.youtubeVideo,
        icon: Education,
        title: "Видео о налогах",
        description: "Для понимания того, как платить налоги с продаж на маркетплейсах, сделали вводное видео",
        buttonText: "more",
        separator: separators.arrow,
    }
]

export const linkCards = [
    {
        type: CardType.statistic
    },
    {
        type: CardType.link,
        colors: {
            from: "#6366f1",
            to: "#a5b4fc"
        },
        pathname: "/marketplaces",
        icon: marketplaces,
        title: "markets",
        description: "Connection and work with marketplaces",
        buttonText: "Connect",
        separator: separators.plus,
    },
    {
        type: CardType.link,
        pathname: "/pim",
        colors: {
            from: "#6b7280",
            to: "#d1d5db"
        },
        icon: addProducts,
        title: "add_products",
        description: "Establishment of product cards in the system",
        buttonText: "add",
        separator: separators.plus,
    },
    {
        type: CardType.link,
        pathname: "/offers",
        colors: {
            from: "#6b7280",
            to: "#d1d5db"
        },
        icon: priceList,
        title: "prices",
        description: "Work with the price list of product cards",
        buttonText: "more",
        separator: separators.arrow,
    },
    {
        type: CardType.link,
        pathname: "/analytics",
        colors: {
            from: "#ef4444",
            to: "#fca5a5"
        },
        icon: analytics,
        title: "Sales analytics",
        description: "Summary analytics on sales in marketplaces",
        buttonText: "more",
        separator: separators.arrow,
    },
    {
        type: CardType.link,
        pathname: "/:id/stocks-fbs",
        icon: warehouse,
        title: "Shipments",
        description: "Functionality for working with warehouses and shipments",
        buttonText: "more",
        separator: separators.arrow,
    },
    {
        type: CardType.link,
        pathname: "/orders",
        colors: {
            from: "#6b7280",
            to: "#d1d5db"
        },
        icon: orders,
        title: "Orders",
        description: "Work with orders from all connected marketplaces",
        buttonText: "more",
        separator: separators.arrow,
    },
    {
        type: CardType.link,
        colors: {
            from: "#22c55e",
            to: "#86efac"
        },
        pathname: "/seller/edit/:id",
        icon: settings,
        title: "company_setup",
        description: "Basic parameters and information of the company",
        buttonText: "more",
        separator: separators.arrow,
    },
]

export const integrationCards = [
    {
        type: CardType.integration,
        link: "https://lk.market/ru/help/1C/start/",
        icon: settings,
        title: "1C LK",
        description: "Integration-1c-card",
        buttonText: "more",
        separator: separators.arrow,
    },
    {
        type: CardType.integration,
        link: "https://lk.market/ru/services/integration/bitrix24",
        icon: settings,
        title: "Bitrix-24",
        description: "Integration-bitrix-card",
        buttonText: "more",
        separator: separators.arrow,
    },
    {
        type: CardType.integration,
        link: "https://lk.market/ru/services/integration",
        icon: settings,
        title: "Other",
        description: "Настроим интеграцию с LK.MARKET для работы с 30+ маркетплейсами",
        buttonText: "more",
        separator: separators.arrow,
    }
]

export const callbackCards = [
    {
        type: CardType.integration,
        icon: Sales,
        title: "Sales development",
        description: "Sales development Description",
        buttonText: "more",
        separator: separators.arrow,
        link: "https://lkmarket.ru/services?utm_referrer=1017887#rec870884934",
    },
    {
        type: CardType.integration,
        icon: AddCards,
        title: "Establishment product cards",
        description: "Establishment product cards Description",
        buttonText: "more",
        separator: separators.arrow,
        link: "https://lk.market/ru/services/cards?utm_referrer=1017887",
    },
    {
        type: CardType.integration,
        icon: Analysis,
        title: "Niche analysis",
        description: "Niche analysis Description",
        buttonText: "more",
        separator: separators.arrow,
        link: "https://sellermarket.ru/blog/1734-analiz-nishi?utm_referrer=1017887",
    },
    {
        type: CardType.integration,
        icon: RegistrationSeller,
        title: "Seller Registration",
        description: "Seller Registration Description",
        buttonText: "more",
        separator: separators.arrow,
        link: "https://sellermarket.ru/blog/1745-registraciya-na-marketplejsah?utm_referrer=1017887",
    },
    {
        type: CardType.integration,
        icon: SEO,
        title: "SEO optimization of product cards",
        description: "SEO optimization of product cards Description",
        buttonText: "more",
        separator: separators.arrow,
        link: "https://sellermarket.ru/blog/1742-seo-product-card?utm_referrer=1017887",
    },
    {
        type: CardType.integration,
        icon: productPacking,
        title: "product_packaging",
        description: "Packaging and labeling products",
        buttonText: "more",
        separator: separators.arrow,
        link: "https://sellermarket.ru/brief/logistics?utm_referrer=1017887#brief",
    },
    {
        type: CardType.integration,
        icon: paymentAccount,
        title: "company_registration",
        description: "Assistance in registering a legal entity and opening an estimated account",
        buttonText: "more",
        separator: separators.arrow,
        link: "https://sellermarket.ru/brief/bank?utm_referrer=1017887#brief",
    },
    {
        type: CardType.callback,
        icon: resolvingFunds,
        title: "factoring",
        description: "Help to start business development",
        buttonText: "Send callback",
        separator: separators.arrow,
        Form: FormResolvingFunds,
    },
    {
        type: CardType.callback,
        icon: BookkeepingIcon,
        title: "Bookkeeping",
        description: "Assistance with bookkeeping",
        buttonText: "Send callback",
        separator: separators.arrow,
        Form: FormBookkepeeping,
    },
    {
        type: CardType.callback,
        icon: Adversting,
        title: "Setting up outdoor advertising",
        description: "Setting up outdoor advertising Description",
        buttonText: "Send callback",
        separator: separators.arrow,
        Form: FormGeneral,
        callbackId: "advertising"
    },
]

export const toolsCards = [
    {
        type: CardType.tools,
        icon: Barcode,
        title: "Генератор штрих-кодов",
        description: "Получите уникальные штрих-коды для любого маркетплейса, в том числе для  Мегамаркета",
        buttonText: "more",
        pathname: "/tools/barcode",
    },
    {
        type: CardType.tools,
        icon: settings,
        title: "Генератор YML/XML",
        description: "Создайте автообновляемые фиды для маркетплейсов и других каналов сбыта",
        buttonText: "more",
        pathname: "/tools",
    },
    {
        type: CardType.callback,
        icon: settings,
        title: "Добавление сотрудников",
        description: "Подключите ваших коллег для совместной работы над данной компанией.",
        buttonText: "Подключить сотрудника",
        separator: separators.arrow,
        Form: FormInviteUser,
        callbackId: "link-seller-account"
    },
    {
        type: CardType.integration,
        icon: settings,
        link: "https://sell.market/marketplaces/russia",
        title: "Подбор маркетплейсов",
        description: "Глобальный агрегатор торговых площадок и прайс-листов",
        buttonText: "more",
        separator: separators.arrow,
    },
    {
        type: CardType.link,
        icon: settings,
        title: "Склады маркетплейсов",
        description: "Интерактивная карта и основная информация по складам маркетплейсов",
        buttonText: "more",
        pathname: "/:id/shipments",
    },
]